import { useEffect } from "react";
import { api } from "./api";

// Presensi untuk statistik dashboard admin:
// - pingKunjungan(cityId): pengunjung unik per perangkat per hari (vid acak di localStorage; termasuk tanpa akun). Dikirim sekali per sesi/kota.
// - useWargaAktif(halaman): detak warga ber-token tiap 60 dtk saat tab terlihat → "warga online" (aktif ≤ 3 menit).
const VID_KEY = "jawsel_vid", TOKEN_KEY = "jawsel_warga_token";

export function vid() {
  let v = localStorage.getItem(VID_KEY);
  if (!v) { v = (crypto.randomUUID?.() || `${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`).replace(/[^A-Za-z0-9_-]/g, ""); localStorage.setItem(VID_KEY, v); }
  return v;
}

export function pingKunjungan(cityId) {
  const key = `jawsel_kunjungan_${cityId || "pulau"}`;
  if (sessionStorage.getItem(key)) return;
  api.kunjungan(vid(), cityId || null).then(() => sessionStorage.setItem(key, "1")).catch(() => {});
}

export function useWargaAktif(halaman) {
  useEffect(() => {
    const kirim = () => { const t = localStorage.getItem(TOKEN_KEY); if (t && document.visibilityState === "visible") api.wargaAktif(t, halaman).catch(() => {}); };
    kirim();
    const iv = setInterval(kirim, 60000);
    document.addEventListener("visibilitychange", kirim);
    return () => { clearInterval(iv); document.removeEventListener("visibilitychange", kirim); };
  }, [halaman]);
}
